import { Box, Typography } from '@mui/material';
import { swapToTokenColumns } from '../table/DashboardData';
import { Tables } from '@/component/pools/table/Tables';
import { ResReadSwapCurrentType, ResReadSwapCurrentType2 } from '@/types';
import { packBigNumbers } from '@/lib/BigNumbers';

export default function SwapToToken({ datas }: { datas: ResReadSwapCurrentType }) {
  const data: ResReadSwapCurrentType2 = {
    betAmount: packBigNumbers(datas.bet_amount),
    totAmount: packBigNumbers(datas.tot_amount),
    count: packBigNumbers(datas.cnt.toString()),
    type: datas.type,
  };
  const list: ResReadSwapCurrentType2[] = [data];

  return (
    <Box sx={{ mb: 3, px: 2, width: '100%' }}>
      <Typography variant="h6" sx={{ mb: 2 }}>
        swap: point to token
      </Typography>

      <Box sx={{ width: '100%' }}>{list && <Tables list={list} columns={swapToTokenColumns} getRowId={(row) => row.type} />}</Box>
    </Box>
  );
}
